import { Component, ElementRef, OnInit, ViewChild  } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { InventariosService } from '../../../core/services/inventarios.service';
import { GrupoOficina } from '../../../core/model/inventories';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-busqueda-oficina',
  templateUrl: './busqueda-oficina.component.html',
  styleUrls: ['./busqueda-oficina.component.css']
})
export class BusquedaOficinaComponent implements OnInit {

  loading = false;
  showModal = true;
  referenciaExternaInput = '';
  referenciaExterna = '';
  descriptorOficina = '';
  onClose = new Subject();
  onQuitar = new Subject();
  onSaveCambios = new Subject<GrupoOficina>();

  constructor(
    private _bsModalRef: BsModalRef,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private inventoryService: InventariosService,
  ) { }

  public ngOnInit(): void {
    this.onClose = new Subject();
  }

  showConfirmationModal(referenciaExterna, descriptorOficina) {
    this.referenciaExterna = referenciaExterna;
    this.descriptorOficina = descriptorOficina;
  }

  public onCancel(): void {
    this.showModal = false;
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public onConfirm(): void {
    this.showModal = false;
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public quitarFiltro() {
    this.showModal = false;
    this.onQuitar.next(true);
    this._bsModalRef.hide();
  }

  save() {

    if (this.referenciaExternaInput.trim() == '')
    {
      this.toastr.warning(this.translateService.instant('generales.mensajeReferenciaExterna2'));
      return;
    }
    this.referenciaExterna = this.referenciaExternaInput;
    this.inventoryService.recuperarOficinaGrupo(this.referenciaExterna).subscribe(
      (resultado: GrupoOficina) => {
        if (resultado != null) {
          // tslint:disable-next-line: max-line-length
          this.toastr.success(this.translateService.instant('generales.mensajeReferenciaExterna1-1') + this.referenciaExterna + this.translateService.instant('generales.mensajeReferenciaExterna1-2'));
        this.onSaveCambios.next(resultado);
        }
      },
      (e: HttpErrorResponse) => {
        if (e.status == 400) {
          // tslint:disable-next-line: max-line-length
          this.toastr.warning(this.translateService.instant('generales.mensajeReferenciaExterna1-1') + this.referenciaExterna + this.translateService.instant('generales.mensajeReferenciaExterna1-3'));
          this.referenciaExterna = '';
        } else {
          // tslint:disable-next-line: max-line-length
          this.toastr.error(this.translateService.instant('generales.mensajeErrorReferenciaExterna1-1') + this.referenciaExterna + this.translateService.instant('generales.mensajeErrorReferenciaExterna1-2'));
          this.referenciaExterna = '';
        }
      }
    );
    this.onConfirm();
  }

}
